module.exports = __webpack_public_path__ + "img/code6.ed434568.png";